import { LOGOUT_REASONS } from "../../consts/auth";
import { ROUTES } from "../../consts/routes";
import { logout } from "../../helpers/auth";
import { history } from "../../history";
import { authService } from "../../services/AuthService";

export const logoutByIdle = (withReason = true) => {
  if (authService.isLoggedIn()) {
    logout(withReason ? { reason: LOGOUT_REASONS.sessionExpire } : {});
  } else if (!window.location.pathname.includes(ROUTES.login())) {
    history.push(ROUTES.login());
  }
};
